import { render, staticRenderFns } from "./ActionInvoicesMenuComponent.vue?vue&type=template&id=462039f2&"
import script from "./ActionInvoicesMenuComponent.vue?vue&type=script&lang=js&"
export * from "./ActionInvoicesMenuComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports